import { showAdminPrograms } from "../renders/show_admin_programs";

export const getPrograms = () => {
  fetch("api/programs/fetch_program_info.php")
    .then((response) => response.json())
    .then((res) => showAdminPrograms(res));
};

export const toggleAttendeeDetails = (e) => {
  e.preventDefault();
  let ac = document.getElementById("ac");
  let pc = document.getElementById("pc");
  let attendeesContainer = document.getElementById("showAttendeesContainer");

  if (attendeesContainer.style.display === "none") {
    attendeesContainer.style.display = "block";
    ac.setAttribute("style", "display: none");
    pc.setAttribute("style", "display: none");
  } else {
    attendeesContainer.style.display = "none";
    ac.style.display = "block";
    pc.style.display = "block";
  }
  if (attendeesContainer.style.display === "none") {
  }
};
